module.exports = __webpack_public_path__ + "static/media/angling-frame-3.d0fccda0.png";


//////////////////
// WEBPACK FOOTER
// ./src/screens/sportSpecificProgressives/angling/angling-frame-3.png
// module id = 3647
// module chunks = 0